import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit
} from '@angular/core';
import { DialogCloseable } from '../dialog-closeable';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogRef } from '../dialog-ref';
import { ToastService } from '@core/state/toast/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ihd-dialog-phone-verification',
    templateUrl: './dialog-phone-verification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'c-dialog active date c-dialog--gutter-xlg',
        '[class.c-dialog--icon]': 'config.icon && config.icon.length > 0',
        '[class.c-dialog--sm]': 'config.small',
        '[class.c-dialog--lg]': '!config.small'
    }
})
export class DialogPhoneVerificationComponent implements OnInit, DialogCloseable {

    public config;
    public verificationForm: FormGroup;
    public submitted: boolean = false;
    public helpHintName: string;
    public minLength: number = 6;
    public maxLength: number = 6;
    public isClosing: boolean = false;
    
    constructor(
        public dialogRef: DialogRef<DialogPhoneVerificationComponent>,
        public cdr: ChangeDetectorRef,
        public toastService: ToastService,
        private translateService: TranslateService
      ) {
          this.config = dialogRef.containerInstance.config;
      }

    ngOnInit() {
        this.helpHintName = this.translateService.instant('Account.Settings.Phone.VerificationCode');

        this.verificationForm = new FormGroup({
            verificationCode: new FormControl(null, [Validators.required, Validators.minLength(this.minLength), Validators.maxLength(this.maxLength)])
        });
        
        this.cdr.markForCheck();
    }

    verify() {
        this.submitted = true;
        if (this.verificationForm.valid) {
            this.isClosing = true;
            this.cdr.detectChanges();

            this.dialogRef.close(this.verificationForm.value.verificationCode);
        } else {
            this.toastService.showWarning('Errors.FormInvalid');
            this.cdr.markForCheck();
        }
    }

    /**
     * Updates the closing status.
     */
    onClose() {
        this.isClosing = true;
        this.cdr.detectChanges();
    }

    onCancel() {
        this.dialogRef.close();
    }
}
